import { render } from "./jxHospitalOrders.vue?vue&type=template&id=1f7bb8a1"
import script from "./jxHospitalOrders.vue?vue&type=script&lang=js"
export * from "./jxHospitalOrders.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__